<div class="app-card container-fluid">
  <div class="row" [style.margin-bottom]="this.config?.data?.dataTable?.searchBar ? '1.5rem' : '0.8rem'">
    <div class="col-md">
      <img *ngIf="config?.image" class="card-logo img-fluid" [src]="config.image" />

      <div class="d-flex justify-content-between align-items-center">
        <div class="card-label">
          <a [routerLink]="config.path"> {{ config.title }} </a>
        </div>

        <button
          class="btn btn-secondary add-button"
          *ngIf="config?.addButton && !config?.addButton?.hidden"
          [routerLink]="config.addButton.path"
        >
          <i class="icon fas fa-plus plus-icon"></i>
          {{ config.addButton.title }}
        </button>
      </div>
    </div>
  </div>
  <ng-template content></ng-template>
</div>
